import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsElsevierComponent } from './simple-icons-elsevier.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsElsevierComponent ],
    exports:      [ SimpleIconsElsevierComponent ],
    bootstrap:    []
})
export class SimpleIconsElsevierModule {}
